import { FC, useEffect } from 'react'
import { config } from '../../../../config'
import { Environment } from '../../../../constants'
import { useAuth, useCustomer, useCustomerProfile } from '../../../../hooks'
import { logRocket } from '../../../../startup'
import { logFactory } from '../../../../util'

const { APP_ENV, LOGROCKET_PROJECT_ID } = config
const liveEnvironments = [Environment.DEVELOPMENT, Environment.PRODUCTION, Environment.STAGING]
const isLiveEnvironment = liveEnvironments.includes(APP_ENV as Environment) && Boolean(LOGROCKET_PROJECT_ID)
const log = logFactory('LogRocketProvider')

const AnalyticsProvider: FC = ({ children }) => {
  const { user } = useAuth()
  const { customer } = useCustomer()
  const { customerProfile: lead } = useCustomerProfile()

  const customerNameParts = [customer?.givenName, customer?.familyName].filter(Boolean)
  const leadNameParts = [lead?.firstName, lead?.lastName].filter(Boolean)
  const customerName = customerNameParts.length ? customerNameParts.join(' ') : undefined
  const leadName = leadNameParts.length ? leadNameParts.join(' ') : undefined

  const customerOrLeadName = customerName || leadName

  useEffect(() => {
    if (!user?.account_id || !isLiveEnvironment) return

    const extraInfo = {
      email: user.email,
      environment: APP_ENV,
      name: customerOrLeadName ? `${user.name} - ${customerOrLeadName}` : user.name,
    }

    const sessionInfo = { extraInfo, id: user.account_id }

    try {
      log('🚀 Setting LogRocket sessionId...', sessionInfo)
      logRocket?.setSessionId(sessionInfo)
      log('🚀 LogRocket sessionId set')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('🟥 Could not establish LogRocket session for the current user', error)
    }
  }, [user?.name, user?.account_id, customerOrLeadName])

  return <>{children}</>
}

export { AnalyticsProvider }
